import React from 'react';

// Campo heredado, con el estilo nuevo. Para pantallas nuevas usa components/ui/Field.
const Input = ({ id, name, type = 'text', autoComplete, placeholder, value, onChange, className = '', label, error = '', leftIcon, rightIcon, onRightIconClick, required }) => {
  const errId = error && id ? `${id}-err` : undefined;
  return (
    <div className="mb-5 w-full">
      {label && (
        <label htmlFor={id} className="block text-[13px] font-medium text-fg mb-1.5">
          {label}{required && <span className="text-signal ml-0.5" aria-hidden>*</span>}
        </label>
      )}
      <div className={`relative flex items-center ${className}`}>
        {leftIcon && <span aria-hidden className="absolute left-3.5 text-fg-faint pointer-events-none">{leftIcon}</span>}
        <input
          id={id} name={name} type={type} autoComplete={autoComplete} placeholder={placeholder} value={value} onChange={onChange} required={required}
          aria-invalid={error ? true : undefined} aria-describedby={errId}
          className={`w-full h-11 rounded-xl bg-raised/60 border text-fg text-sm placeholder:text-fg-faint transition-colors
            focus:outline-none focus-visible:border-live focus-visible:ring-2 focus-visible:ring-live/30 hover:border-fg/20
            ${error ? 'border-signal' : 'border-line'} ${leftIcon ? 'pl-10' : 'pl-3.5'} ${rightIcon ? 'pr-11' : 'pr-3.5'}`}
        />
        {rightIcon && (onRightIconClick
          ? <button type="button" onClick={onRightIconClick} aria-label="Alternar" className="absolute right-1.5 h-8 w-8 grid place-items-center rounded-full text-fg-faint hover:text-fg hover:bg-raised focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-live/70">{rightIcon}</button>
          : <span aria-hidden className="absolute right-3.5 text-fg-faint">{rightIcon}</span>)}
      </div>
      {error && <p id={errId} role="alert" className="mt-1.5 text-[12.5px] text-signal">{error}</p>}
    </div>
  );
};

export default Input;
